import m from "../../../../geodata/es2015/region/world/latinAmericaUltra";
window.am4geodata_region_world_latinAmericaUltra = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/latinAmericaUltra.js
// module id = null
// module chunks = 